import React from 'react'
import Layout from '../components/layout'
import Welcome from '../components/index/welcome'
import Advantages from '../components/index/advantages'
import Services from '../components/index/services'
import Prices from '../components/index/prices'
import Contact from '../components/index/contact'
import Process from '../components/index/process'
import Order from '../components/index/order'
import * as styles from './index.module.css'

const IndexPage = (props) => {
  return (
    <Layout>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <Welcome />
          <Advantages />
        </div>
      </div>
      <div className={styles.container}>
        <Services />
      </div>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <Prices />
          <Contact />
        </div>
      </div>
      <div className={styles.container}>
        <Process />
      </div>
      <div className={styles.wrapperHighlight}>
        <div className={styles.container}>
          <Order />
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage
